/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Resource UID list loading hooks 

import React from 'react';
import {NULL_UUID_STRING} from "../../constants/dataConstants";
import useUIDListLoad from "../../clientShared/hooks/useUIDListLoad";
import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../constants/resourceTypeConstants";

export const useUserAccountUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT, sortingColumnName, accountUID, 'accountUIDList');
};

export const useUserAccountBalanceUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_BALANCE, sortingColumnName, accountUID, 'accountUIDList');
};

export const useUserAccountBalanceSourceUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE, sortingColumnName, accountUID, 'sourceUIDList');
};

export const useUserHistoryEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_HISTORY_ENTRY, sortingColumnName, accountUID, 'entryUIDList');
};

export const useBalanceChangeLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BALANCE_CHANGE_LOG, sortingColumnName, accountUID, 'changeLogUIDList');
};

export const useInternationalUserBankAccountUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT, sortingColumnName, accountUID, 'bankAccountUIDList');
};

export const useUSDomesticUserBankAccountUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT, sortingColumnName, accountUID, 'bankAccountUIDList');
};

export const useUserBankAccountDeltaUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA, sortingColumnName, accountUID, 'deltaUIDList');
};

export const useUserAccountSettingsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_SETTINGS, sortingColumnName, accountUID, 'accountUIDList');
};

export const useAdminGhostUserAccountUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST, sortingColumnName, accountUID, 'ghostAccountUIDList');
};

export const useUserAccountFinalizationUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION, sortingColumnName, accountUID, 'accountUIDList');
};

export const useThirdPartyUserAccountMappingUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING, sortingColumnName, accountUID, 'accountUIDList');
};

export const usePreviousEmailAddressUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS, sortingColumnName, accountUID, 'previousEmailUIDList');
};

export const usePendingEmailChangeUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PENDING_EMAIL_CHANGE, sortingColumnName, accountUID, 'changeUIDList');
};

export const useArchivedPendingEmailChangeUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE, sortingColumnName, accountUID, 'changeUIDList');
};

export const usePasswordUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PASSWORD, sortingColumnName, accountUID, 'accountUIDList');
};

export const useExpiredPasswordUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EXPIRED_PASSWORD, sortingColumnName, accountUID, 'expiredPasswordUIDList');
};

export const usePasswordResetUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PASSWORD_RESET, sortingColumnName, accountUID, 'resetUIDList');
};

export const useDepositUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT, sortingColumnName, accountUID, 'depositUIDList');
};

export const useDepositInviteUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_INVITE, sortingColumnName, accountUID, 'depositUIDList');
};

export const useDepositAdjustmentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_ADJUSTMENT, sortingColumnName, accountUID, 'adjustmentUIDList');
};

export const useDepositInterestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_INTEREST, sortingColumnName, accountUID, 'interestUIDList');
};

export const useDepositHistoryEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY, sortingColumnName, accountUID, 'entryUIDList');
};

export const useDepositCloseRequestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST, sortingColumnName, accountUID, 'depositUIDList');
};

export const useDepositUserStatsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_USER_STATS, sortingColumnName, accountUID, 'accountUIDList');
};

export const useDepositBankMappingUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_BANK_MAPPING, sortingColumnName, accountUID, 'mapUIDList');
};

export const useDepositBulkImportUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSITS_BULK_IMPORT, sortingColumnName, accountUID, 'bulkImportUIDList');
};

export const useDepositInterestLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_INTEREST_LOG, sortingColumnName, accountUID, 'entryUIDList');
};

export const useArchivedDepositCloseRequestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST, sortingColumnName, accountUID, 'archiveUIDList');
};

export const useDepositWithheldFundsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS, sortingColumnName, accountUID, 'withheldUIDList');
};

export const usePMCReportTimetableUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PMC_REPORT_TIMETABLE, sortingColumnName, accountUID, 'timetableUIDList');
};

export const useDepositGroupUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_GROUP, sortingColumnName, accountUID, 'groupUIDList');
};

export const useDepositPostCloseAdjustmentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT, sortingColumnName, accountUID, 'adjustmentUIDList');
};

export const useDepositUserGroupUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIT_USER_GROUP, sortingColumnName, accountUID, 'depositUIDList');
};

export const usePropertyGroupUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PROPERTY_GROUP, sortingColumnName, accountUID, 'groupUIDList');
};

export const usePropertyUserGroupUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PROPERTY_USER_GROUP, sortingColumnName, accountUID, 'propertyUIDList');
};

export const useDisputeUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DISPUTE, sortingColumnName, accountUID, 'disputeUIDList');
};

export const useDisputeSplitUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DISPUTE_SPLIT, sortingColumnName, accountUID, 'splitUIDList');
};

export const useDisputeInterventionRequestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST, sortingColumnName, accountUID, 'requestUIDList');
};

export const usePropertyUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PROPERTY, sortingColumnName, accountUID, 'propertyUIDList');
};

export const usePropertyAddressUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PROPERTY_ADDRESS, sortingColumnName, accountUID, 'propertyAddressUIDList');
};

export const useComplianceUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_COMPLIANCE, sortingColumnName, accountUID, 'complianceUIDList');
};

export const useComplianceRuleUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_COMPLIANCE_RULE, sortingColumnName, accountUID, 'complianceRuleUIDList');
};

export const useComplianceHistoryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_COMPLIANCE_HISTORY, sortingColumnName, accountUID, 'complianceHistoryUIDList');
};

export const useEmailTemplateUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EMAIL_TEMPLATE, sortingColumnName, accountUID, 'templateUIDList');
};

export const useEmailVerificationUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EMAIL_VERIFICATION, sortingColumnName, accountUID, 'verificationUIDList');
};

export const useEmailVerificationRecordUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD, sortingColumnName, accountUID, 'verificationUIDList');
};

export const useEmailEventUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EMAIL_EVENT, sortingColumnName, accountUID, 'eventUIDList');
};

export const useSentEmailUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SENT_EMAIL, sortingColumnName, accountUID, 'emailUIDList');
};

export const useMailboxUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_MAILBOX, sortingColumnName, accountUID, 'mailboxUIDList');
};

export const useMailboxMetaDataUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_MAILBOX_META_DATA, sortingColumnName, accountUID, 'metaDataUIDList');
};

export const useMailboxMessageUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_MAILBOX_MESSAGE, sortingColumnName, accountUID, 'messageUIDList');
};

export const usePermissionEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PERMISSION_ENTRY, sortingColumnName, accountUID, 'permissionUIDList');
};

export const usePermissionLogEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PERMISSION_LOG_ENTRY, sortingColumnName, accountUID, 'logEntryUIDList');
};

export const usePermissionsOrganizationSettingsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS, sortingColumnName, accountUID, 'organizationUIDList');
};

export const useResourcePermissionUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_RESOURCE_PERMISSIONS, sortingColumnName, accountUID, 'permissionUIDList');
};

export const useOrganizationUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ORGANIZATION, sortingColumnName, accountUID, 'organizationUIDList');
};

export const useOrganizationResourcePermissionRuleUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE, sortingColumnName, accountUID, 'ruleUIDList');
};

export const useInvoiceUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_INVOICE, sortingColumnName, accountUID, 'invoiceUIDList');
};

export const useInvoiceItemUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_INVOICE_ITEM, sortingColumnName, accountUID, 'invoiceItemUIDList');
};

export const usePaymentRequestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PAYMENT_REQUEST, sortingColumnName, accountUID, 'requestUIDList');
};

export const useStripePaymentLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_STRIPE_PAYMENT_LOG, sortingColumnName, accountUID, 'paymentLogUIDList');
};

export const useUserWithdrawUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_WITHDRAW, sortingColumnName, accountUID, 'withdrawUIDList');
};

export const usePriorityACHPaymentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PRIORITY_ACH_PAYMENT, sortingColumnName, accountUID, 'paymentUIDList');
};

export const usePriorityACHRecurringPaymentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT, sortingColumnName, accountUID, 'recurringPaymentUIDList');
};

export const useLoanApplicationUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_LOAN_APPLICATION, sortingColumnName, accountUID, 'applicationUIDList');
};

export const useLoanSystemInfoUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_LOAN_SYSTEM_INFO, sortingColumnName, accountUID, 'loanInfoUIDList');
};

export const useLoanUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_LOAN, sortingColumnName, accountUID, 'loanUIDList');
};

export const useLoanHistoryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_LOAN_HISTORY, sortingColumnName, accountUID, 'loanUIDList');
};

export const useLoanPaymentLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_LOAN_PAYMENT_LOG, sortingColumnName, accountUID, 'logUIDList');
};

export const useStripeWebhookLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_STRIPE_WEBHOOK_LOG, sortingColumnName, accountUID, 'logUIDList');
};

export const useUserAccountPaymentProviderInfoUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO, sortingColumnName, accountUID, 'accountUIDList');
};

export const useSezzleOrderUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SEZZLE_ORDER, sortingColumnName, accountUID, 'sezzleOrderUIDList');
};

export const useSezzleWebhookEventUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT, sortingColumnName, accountUID, 'eventUIDList');
};

export const useBankAccountUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BANK_ACCOUNT, sortingColumnName, accountUID, 'bankAccountUIDList');
};

export const useBankAccountHistoricalInterestRateUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE, sortingColumnName, accountUID, 'rateHistoryUIDList');
};

export const useBankAccountInterestUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BANK_ACCOUNT_INTEREST, sortingColumnName, accountUID, 'interestUIDList');
};

export const useBankAccountBalanceRecordUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD, sortingColumnName, accountUID, 'recordUIDList');
};

export const useBankTransferUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BANK_TRANSFER, sortingColumnName, accountUID, 'transferUIDList');
};

export const useBulkFundsTransferUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BULK_FUNDS_TRANSFER, sortingColumnName, accountUID, 'bulkTransferUIDList');
};

export const useFundsLockUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_FUNDS_LOCK, sortingColumnName, accountUID, 'lockUIDList');
};

export const useFundsLockReleaseLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG, sortingColumnName, accountUID, 'releaseLogUIDList');
};

export const useReleasedFundsLockUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_RELEASED_FUNDS_LOCK, sortingColumnName, accountUID, 'lockUIDList');
};

export const useBalanceSourceTransferUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER, sortingColumnName, accountUID, 'transferUIDList');
};

export const useCreditUserAccountLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG, sortingColumnName, accountUID, 'creditLogUIDList');
};

export const useEventUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EVENT, sortingColumnName, accountUID, 'eventUIDList');
};

export const useEventHookUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_EVENT_HOOK, sortingColumnName, accountUID, 'hookUIDList');
};

export const useNotificationUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_NOTIFICATION, sortingColumnName, accountUID, 'notificationUIDList');
};

export const useActionItemUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ACTION_ITEM, sortingColumnName, accountUID, 'itemUIDList');
};

export const useUpdateLogUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_UPDATE_LOG_ENTRY, sortingColumnName, accountUID, 'entryUIDList');
};

export const useStorageFileUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_STORAGE_FILE, sortingColumnName, accountUID, 'fileUIDList');
};

export const useAttachedStorageFilesUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ATTACHED_STORAGE_FILES, sortingColumnName, accountUID, 'attachedFilesUIDList');
};

export const useSystemHistoryEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY, sortingColumnName, accountUID, 'entryUIDList');
};

export const useSnapshotUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SNAPSHOT, sortingColumnName, accountUID, 'snapshotUIDList');
};

export const useIPAddressUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'last_seen_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_IP_ADDRESS, sortingColumnName, accountUID, 'ipUIDList');
};

export const useKnownIPAddressUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'last_use_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_KNOWN_IP_ADDRESS, sortingColumnName, accountUID, 'knownIpUIDList');
};

export const useUserAgentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'last_seen_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_USER_AGENT, sortingColumnName, accountUID, 'userAgentUIDList');
};

export const useKnownUserAgentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'last_use_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_KNOWN_USER_AGENT, sortingColumnName, accountUID, 'knownUserAgentUIDList');
};

export const useSystemStatsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_SYSTEM_STATS, sortingColumnName, accountUID, 'statsUIDList');
};

export const useResourceNoteUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_RESOURCE_NOTE, sortingColumnName, accountUID, 'notesUIDList');
};

export const useDeposifyTagUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_DEPOSIFY_TAG, sortingColumnName, accountUID, 'tagUIDList');
};

export const usePermanentLinkUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_PERMANENT_LINK, sortingColumnName, accountUID, 'linkUIDList');
};

export const useOnlineUserUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'last_login_refresh_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_ONLINE_USER, sortingColumnName, accountUID, 'onlineUserUIDList');
};

export const useFrontendGeneralSettingsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS, sortingColumnName, accountUID, 'settingsUIDList');
};

export const useYardiScreeningWorksProXMLUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML, sortingColumnName, accountUID, 'xmlUIDList');
};

export const useYardiVoyagerXMLUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_XML, sortingColumnName, accountUID, 'voyagerXmlUIDList');
};

export const useYardiVoyagerTransactionUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION, sortingColumnName, accountUID, 'voyagerTransactionUIDList');
};

export const useYardiVoyagerResidentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT, sortingColumnName, accountUID, 'voyagerResidentUIDList');
};

export const useYardiVoyagerResidentCustomColumnUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN, sortingColumnName, accountUID, 'customColumnUIDList');
};

export const useYardiVoyagerPropertyUnitUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT, sortingColumnName, accountUID, 'voyagerPropertyUnitUIDList');
};

export const useYardiVoyagerPropertyUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY, sortingColumnName, accountUID, 'voyagerPropertyUIDList');
};

export const useYardiVoyagerPMCServiceInterfaceVersionUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION, sortingColumnName, accountUID, 'serviceInterfaceVersionUIDList');
};

export const useYardiVoyagerPMCUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC, sortingColumnName, accountUID, 'deposifyPmcAccountUIDList');
};

export const useYardiVoyagerPMCCredentialsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS, sortingColumnName, accountUID, 'deposifyPmcAccountUIDList');
};

export const useYardiVoyagerPetUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PET, sortingColumnName, accountUID, 'petUIDList');
};

export const useYardiVoyagerILSGuestCardEventUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT, sortingColumnName, accountUID, 'guestCardEventUIDList');
};

export const useYardiVoyagerChargeUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_CHARGE, sortingColumnName, accountUID, 'voyagerChargeUIDList');
};

export const useYardiVoyagerChargeCodeUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE, sortingColumnName, accountUID, 'chargeCodeUIDList');
};

export const useYardiVoyagerDepositCreateIntentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT, sortingColumnName, accountUID, 'createIntentUIDList');
};

export const useYardiVoyagerDepositCloseIntentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT, sortingColumnName, accountUID, 'closeIntentUIDList');
};

export const useYardiVoyagerDepositWithholdIntentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT, sortingColumnName, accountUID, 'withholdIntentUIDList');
};

export const useYardiVoyagerEventUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_EVENT, sortingColumnName, accountUID, 'eventUIDList');
};

export const useYardiVoyagerFlexDepositIntentUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT, sortingColumnName, accountUID, 'flexIntentUIDList');
};

export const useYardiVoyagerPhoneUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PHONE, sortingColumnName, accountUID, 'phoneUIDList');
};

export const useYardiVoyagerOtherOccupantUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT, sortingColumnName, accountUID, 'otherOccupantUIDList');
};

export const useYardiVoyagerPMCCustomColumnSettingsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS, sortingColumnName, accountUID, 'columnUIDList');
};

export const useYardiVoyagerPMCStatsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS, sortingColumnName, accountUID, 'statsUIDList');
};

export const useYardiVoyagerPMCStatsCollectorUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR, sortingColumnName, accountUID, 'statsUIDList');
};

export const useYardiVoyagerActiveScanLogEntryUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY, sortingColumnName, accountUID, 'logUIDList');
};

export const useYardiVoyagerSystemSettingsUIDListLoader = (accountUID = NULL_UUID_STRING, sortingColumnName = 'created_timestamp') => {
	return useUIDListLoad(RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS, sortingColumnName, accountUID, 'settingsUIDList');
};

